import { message } from 'antd';
import { useMutation, useQueryClient } from 'react-query';

import { useApi } from '../../context/ApiContext';

export const useTransfersAccount = () => {
  const queryClient = useQueryClient();
  const client = useApi();

  return useMutation(
    (values) => client.post('/multiaccess/kam/transferOneClientToAnotherKam', values).then((res) => res.data),
    {
      onSuccess() {
        queryClient.invalidateQueries('get-multi-access-users');
      },
      onError() {
        message.error('Request failed to transfers the account');
      },
    },
  );
};
